@if (showSupportDevTool) {
  <ucs-dropdown-menu [iconShape]="'tool'" [type]="'top-menu'">
    <button
      (click)="refreshIndex()"
      class="dropdown-item"
      type="button">
      Refresh Index
    </button>
  </ucs-dropdown-menu>
}